export const LOGIN = 'Login'
export const GOOGLE = 'Google'
export const FACEBOOK = 'Facebook'
export const APPLE = 'Apple'

export const routePaths = {
  DEFAULT: '/',
  HOME: '/home',
  LIBRARY: '/library',
  LOGIN: '/login',
  MAGAZINE: '/magazine',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  HTTP_404: '/404'
}

export const UPDATE_EMAIL_ADDRESS = 'UPDATE_EMAIL_ADDRESS'
export const UPDATE_UUID = 'UPDATE_UUID'
export const UPDATE_AUTH_TOKEN = 'UPDATE_AUTH_TOKEN'
export const UPDATE_REFRESH_TOKEN = 'UPDATE_REFRESH_TOKEN'
export const LOG_OUT = 'LOG_OUT'
export const UPDATE_THEME = 'UPDATE_THEME'

export const DARK = 'dark'
export const LIGHT = 'light'

export const REMOVE_ARROR_ON_LARGE_IMAGE_DEVICE = [
  'tablet',
  'smallTablet',
  'mobile'
]
export const REMOVE_ARROW_ON_SMALL_IMAGE_DEVICE = [
  'tablet',
  'smallTablet',
  'mobile',
  'mediumPhone',
  'smallPhone'
]

export const responsiveLarge = (isLandScape: boolean) => ({
  xxxxlDesktop: {
    breakpoint: { max: 50000, min: 2265 },
    items: isLandScape ? 8 : 7,
    partialVisibilityGutter: 20,
    slidesToSlide: isLandScape ? 8 : 7
  },
  xxxlDesktop: {
    breakpoint: { max: 2260, min: 2015 },
    items: isLandScape ? 7 : 6,
    partialVisibilityGutter: 20,
    slidesToSlide: isLandScape ? 7 : 6
  },
  xxlDesktop: {
    breakpoint: { max: 2010, min: 1765 },
    items: isLandScape ? 6 : 5,
    partialVisibilityGutter: 20,
    slidesToSlide: isLandScape ? 6 : 5
  },
  superLargeDesktop: {
    breakpoint: { max: 1760, min: 1520 },
    items: isLandScape ? 6 : 5,
    partialVisibilityGutter: 20,
    slidesToSlide: isLandScape ? 6 : 5
  },
  desktop: {
    breakpoint: { max: 1510, min: 1265 },
    items: isLandScape ? 5 : 4,
    partialVisibilityGutter: 20,
    slidesToSlide: isLandScape ? 5 : 4
  },
  tablet: {
    breakpoint: { max: 1260, min: 1011 },
    items: isLandScape ? 4 : 3,
    partialVisibilityGutter: 20,
    slidesToSlide: isLandScape ? 4 : 3
  },
  smallTablet: {
    breakpoint: { max: 1010, min: 741 },
    items: isLandScape ? 3 : 2,
    partialVisibilityGutter: 20,
    slidesToSlide: isLandScape ? 3 : 2
  },
  mobile: {
    breakpoint: { max: 740, min: 0 },
    items: isLandScape ? 2 : 1,
    partialVisibilityGutter: 20
  }
})

export const responsiveSmall = (isLandScape: boolean) => ({
  xxxxlDesktop: {
    breakpoint: { max: 50000, min: 3150 },
    items: isLandScape ? 18 : 16,
    partialVisibilityGutter: 10,
    slidesToSlide: isLandScape ? 18 : 16
  },
  xxxlDesktop: {
    breakpoint: { max: 3150, min: 2800 },
    items: isLandScape ? 16 : 14,
    partialVisibilityGutter: 10,
    slidesToSlide: isLandScape ? 16 : 14
  },
  xxlDesktop: {
    breakpoint: { max: 2800, min: 2450 },
    items: isLandScape ? 14 : 12,
    partialVisibilityGutter: 10,
    slidesToSlide: isLandScape ? 14 : 12
  },
  superLargeDesktop: {
    breakpoint: { max: 2450, min: 2100 },
    items: isLandScape ? 12 : 10,
    partialVisibilityGutter: 10,
    slidesToSlide: isLandScape ? 12 : 10
  },
  desktop: {
    breakpoint: { max: 1750, min: 1400 },
    items: isLandScape ? 10 : 8,
    partialVisibilityGutter: 10,
    slidesToSlide: isLandScape ? 10 : 8
  },
  tablet: {
    breakpoint: { max: 1400, min: 1050 },
    items: isLandScape ? 8 : 6,
    partialVisibilityGutter: 10,
    slidesToSlide: isLandScape ? 8 : 6
  },
  smallTablet: {
    breakpoint: { max: 1050, min: 700 },
    items: isLandScape ? 6 : 4,
    partialVisibilityGutter: 10,
    slidesToSlide: isLandScape ? 6 : 4
  },
  mediumPhone: {
    breakpoint: { max: 700, min: 350 },
    items: isLandScape ? 4 : 2,
    partialVisibilityGutter: 5,
    slidesToSlide: isLandScape ? 4 : 2
  },
  smallPhone: {
    breakpoint: { max: 350, min: 0 },
    items: isLandScape ? 2 : 1,
    partialVisibilityGutter: 5
  }
})
